module.exports = "<div>\n  <input class='regexp' [(ngModel)]='regexp' />\n  <input class='weight'[(ngModel)]='weight' />\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/criterion-item-box/criterion-item-box.component.html
// module id = 419
// module chunks = 0